import {FC} from "react";
import {EmailLoginButton, toProviderButton} from "../sso/SsoButtons";
import {AuthProviderType} from "../../domain/providers";
import {LoginFormWithResetPassword} from "../login/LoginFormWithResetPassword";

type Props = {
  provider: AuthProviderType;
  email: string;
  emailLoginSendTo?: string;
  showPasswordOnlyLoginForm?: boolean;
}

export const ContinueWithAuthProvider: FC<Props> = ({email, provider, emailLoginSendTo, showPasswordOnlyLoginForm}) => {
  let continueWith = <></>

  if (!email || !provider) {
    return null;
  }

  if (provider === AuthProviderType.Password) {
    continueWith = showPasswordOnlyLoginForm ?
      <LoginFormWithResetPassword preloadEmail={email} hideEmail={true} readOnlyEmail={true}/> :
      EmailLoginButton(emailLoginSendTo);
  } else {
    const ssoButton = toProviderButton(provider, "login");
    if (!ssoButton) {
      console.error(`unsupported provider: ${provider}`);
      return null;
    }
    continueWith = ssoButton;
  }
  return <div className="flex items-center justify-center pt-2">{continueWith}</div>;
};
